import { render, staticRenderFns } from "./rateTable.vue?vue&type=template&id=688b46aa&scoped=true"
import script from "./rateTable.vue?vue&type=script&lang=js"
export * from "./rateTable.vue?vue&type=script&lang=js"
import style0 from "./rateTable.vue?vue&type=style&index=0&id=688b46aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b46aa",
  null
  
)

export default component.exports